export default __webpack_public_path__ + "static/media/user-card.84b26198.svg";